"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ToggleButton: ()=>ToggleButton,
    Logo: ()=>Logo,
    Container: ()=>Container,
    LogoWrapper: ()=>LogoWrapper
});
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const pulseShadow = /*#__PURE__*/ (0, external_styled_components_namespaceObject.keyframes)([
    "0%{box-shadow:0px 0px 30px 15px rgba(193,192,192,0.4);}50%{box-shadow:0px 0px 10px 5px rgba(64,64,64,0.6);}100%{box-shadow:0px 0px 30px 15px rgba(193,192,192,0.4);}"
]);
const Container = /*#__PURE__*/ external_styled_components_default().div.withConfig({
    displayName: "BotWithAnumatedBorder.styles__Container"
})([
    "display:flex;flex-direction:column;align-items:center;justify-content:center;"
]);
const LogoWrapper = /*#__PURE__*/ external_styled_components_default().div.withConfig({
    displayName: "BotWithAnumatedBorder.styles__LogoWrapper"
})([
    "width:88px;height:88px;position:relative;top:50px;display:flex;border-radius:50%;align-items:center;justify-content:center;",
    ""
], ({ isSpeaking })=>isSpeaking && /*#__PURE__*/ (0, external_styled_components_namespaceObject.css)([
        "animation:",
        " 2.5s cubic-bezier(0.42,0,0.58,1) infinite;"
    ], pulseShadow));
const Logo = /*#__PURE__*/ external_styled_components_default().img.withConfig({
    displayName: "BotWithAnumatedBorder.styles__Logo"
})([
    "width:100%;height:100%;border-radius:50%;"
]);
const ToggleButton = /*#__PURE__*/ external_styled_components_default().button.withConfig({
    displayName: "BotWithAnumatedBorder.styles__ToggleButton"
})([
    "margin-top:20px;padding:10px 20px;font-size:16px;cursor:pointer;"
]);
exports.Container = __webpack_exports__.Container;
exports.Logo = __webpack_exports__.Logo;
exports.LogoWrapper = __webpack_exports__.LogoWrapper;
exports.ToggleButton = __webpack_exports__.ToggleButton;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Container",
    "Logo",
    "LogoWrapper",
    "ToggleButton"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
